import { memo } from 'react';
import ReactWordcloud from 'react-wordcloud';

export const WordCloud = memo(({ options, wordsInTitre }) => {
  return <ReactWordcloud options={options} words={wordsInTitre} />;
});
